import { Navigate, useParams } from "react-router";

// Die frühere Bearbeiten-Seite einer Ausschreibung (/share/listings/:listingId/edit). Bearbeitet wird
// jetzt im Dashboard (Titel, Beschreibung, Flächen) und in seinen Einstellungen; ein alter Link oder
// Lesezeichen landet dort, statt auf einer Seite, die es nicht mehr gibt.
export function ListingEditRedirect() {
  const { listingId = "" } = useParams();
  return <Navigate to={`/share/listings/${listingId}`} replace />;
}
